// import vibrate from 'utils/vibrate';
import { FONT_BOLD } from '../../constants/AppConstants';

const BASE_HEIGHT = 86;
const BASE_WIDTH = 86;
const CORNER_RADIUS = 24;

const COLOUR_PRIMARY = 0xffffff;
const COLOUR_SECONDRY = 0x505050;
const COLOUR_TERTIARY = 0xcccccc;

const COLOURS_SECONDRY = {
  up: { bg: COLOUR_PRIMARY, font: COLOUR_SECONDRY },
  over: { bg: COLOUR_SECONDRY, font: COLOUR_PRIMARY },
  down: { bg: COLOUR_SECONDRY, font: COLOUR_PRIMARY },
  disabled: { bg: COLOUR_PRIMARY, font: COLOUR_SECONDRY, alpha: 0.5 },
};
const COLOURS_PRIMARY = {
  up: { bg: COLOUR_SECONDRY, font: COLOUR_PRIMARY },
  over: { bg: COLOUR_PRIMARY, font: COLOUR_SECONDRY },
  down: { bg: COLOUR_PRIMARY, font: COLOUR_SECONDRY },
  disabled: { bg: COLOUR_SECONDRY, font: COLOUR_PRIMARY, alpha: 0.5 },
};
const COLOURS_TERTIARY = {
  up: { bg: COLOUR_TERTIARY, font: COLOUR_SECONDRY },
  over: { bg: COLOUR_SECONDRY, font: COLOUR_TERTIARY },
  down: { bg: COLOUR_SECONDRY, font: COLOUR_TERTIARY },
  disabled: { bg: COLOUR_TERTIARY, font: COLOUR_SECONDRY, alpha: 0.5 },
};

export const BUTTON_PRIMARY = 'PRIMARY';
export const BUTTON_SECONDRY = 'SECONDRY';
export const BUTTON_TERTIARY = 'TERTIARY';

export default class BtnDefault extends Phaser.Sprite {
  constructor({
    game,
    id,
    sfxID,
    ariaLabelID,
    label,
    icon,
    hierarchy,
    labelLeft,
    enabled = true,
    minWidth = true,
    minSizeNarrow = 42,
    minSizeWide = 70,
    maxSizeNarrow = 76,
    maxSizeWide = 128,
  }) {
    super(game);
    this.id = id;
    this.sfxID = sfxID;
    this.ariaLabelID = ariaLabelID;
    this.btnEnabled = true;
    this.disabled = false;
    this.minSizeNarrow = minSizeNarrow;
    this.minSizeWide = minSizeWide;
    this.maxSizeNarrow = maxSizeNarrow;
    this.maxSizeWide = maxSizeWide;

    this.buttonStates = COLOURS_PRIMARY;
    switch (hierarchy) {
      case BUTTON_PRIMARY:
        this.buttonStates = COLOURS_PRIMARY;
        break;
      case BUTTON_SECONDRY:
        this.buttonStates = COLOURS_SECONDRY;
        break;
      case BUTTON_TERTIARY:
        this.buttonStates = COLOURS_TERTIARY;
        break;
    }

    this.costume = this.createCostume({ icon, label, labelLeft, minWidth });
    this.addChild(this.costume);

    this.isOver = false;
    this.isMute = false;
    // this.inputEnabled = true;
    // this.input.useHandCursor = true;
    // this.btnEnabled = enabled;

    // signals
    this.onInputDown = new Phaser.Signal();

    // recalculate size based if screen changes
    this.game.scale.onSizeChange.add(this.manageSize, this);
    this.manageSize();

    // listen for pause status
    this.bindedHandlePausedMouseMove = this.handlePausedMouseMove.bind(this);
    this.game.onPause.add(this.handleGamePaused, this);
    this.game.onResume.add(this.handleGameResumed, this);

    this.isOver = false;

    if (enabled) {
      this.enable();
    }
    if (this.game.paused) {
      this.handleGamePaused();
    }
    this.manageSize();
    this.updateIconGraphic();
  }

  createCostume({ icon, label, labelLeft, minWidth }) {
    const costume = this.game.make.group();

    costume.contentDisplay = this.createContentDisplay(icon, label, labelLeft);
    costume.contentDisplay.anchor.set(0.5);
    costume.addChild(costume.contentDisplay);

    let buttonWidth = 0;
    if (label) {
      buttonWidth = Math.max(minWidth ? 255 : 0, costume.contentDisplay.width + 25);
    } else {
      buttonWidth = BASE_WIDTH;
    }

    const panelTexture = this.createContentPanelTexture(buttonWidth, BASE_HEIGHT, CORNER_RADIUS);

    // tint andd offset graphic to create drop shadow
    costume.shadow = this.game.make.image(0, 5, panelTexture);
    costume.shadow.tint = '0x000000';
    costume.shadow.alpha = 0.15;

    // place coloured panel over shadow
    costume.panel = this.game.make.image(0, 0, panelTexture);
    costume.panel.tint = this.buttonStates.up.bg;

    // make sure they sit behind the label
    costume.addChildAt(costume.panel, 0);
    costume.addChildAt(costume.shadow, 0);

    costume.contentDisplay.x = costume.panel.width * 0.5;
    costume.contentDisplay.y = costume.panel.height * 0.5;

    return costume;
  }

  createContentPanelTexture(width, height, cornerradius) {
    const contentPanelId = 'BtnDefaultPanel' + width + height + cornerradius;
    if (!this.game.cache.checkRenderTextureKey(contentPanelId)) {
      // create a graphic to render the base texture
      const bgGraphic = this.game.make.graphics();
      bgGraphic.beginFill(0xffffff);
      bgGraphic.drawRoundedRect(0, 0, width, height, cornerradius);
      this.game.cache.addRenderTexture(contentPanelId, bgGraphic.generateTexture());
      // destroy graphic, we don;t want this now
      bgGraphic.destroy();
    }
    return this.game.cache.getRenderTexture(contentPanelId).texture;
  }

  createContentDisplay(icon, label, labelLeft) {
    // if label, render to group and create texture
    if (label) {
      const textureid = 'BtnDefaultContent' + icon + label + (labelLeft ? 1 : 0);

      // check cache for existing texture
      if (!this.game.cache.checkRenderTextureKey(textureid)) {
        const content = this.game.make.group();
        let labelText;
        let iconDisplay;
        if (label) {
          labelText = this.game.make.text(0, 0, this.game.copy.getCopy(label), {
            font: '30px ' + FONT_BOLD,
            fill: '#ffffff',
          });
          content.add(labelText);
        }

        // check if we need an icon
        if (icon) {
          iconDisplay = this.game.make.image(0, 0, 'uiicons', icon);
          // icons are slightly smaller with a label
          iconDisplay.scale.set(0.6);
          content.add(iconDisplay);
        }
        // position icon and label
        if (iconDisplay && !labelLeft) {
          labelText.x = iconDisplay.x + iconDisplay.width + 5;
        } else if (iconDisplay) {
          iconDisplay.x = labelText.x + labelText.width + 5;
        }
        if (iconDisplay) {
          labelText.y = iconDisplay ? iconDisplay.height * 0.5 - labelText.height * 0.46 : 0;
        }

        // add texture to cache so we can reuse if needed
        this.game.cache.addRenderTexture(textureid, content.generateTexture());
        content.destroy();
      }
      return this.game.make.image(0, 0, this.game.cache.getRenderTexture(textureid).texture);
    }

    return this.game.make.image(0, 0, 'uiicons', icon);
  }

  get width() {
    return this.costume.panel.width * this.costume.scale.x;
  }
  get height() {
    return this.costume.panel.height * this.costume.scale.y;
  }

  /*
  =============================================================================================================
    ENABLE / DISABLE
  =============================================================================================================
  */

  init() {
    if (this.game) {
      const mx = this.game.input.activePointer.x;
      const my = this.game.input.activePointer.y;
      if (this.isWithinBounds(mx, my)) {
        // this.onOver();
      } else {
        // this.onOut();
      }
    }
    if (this.btnEnabled) {
      this.enable();
    }
  }

  setMute(muted = false) {
    this.isMute = muted;
  }

  enable() {
    this.btnEnabled = true;
    this.inputEnabled = true;
    this.input.useHandCursor = true;
    this.events.onInputDown.add(this.inputDown, this);
    this.events.onInputOver.add(this.onOver, this);
    this.events.onInputOut.add(this.onOut, this);
    this.updateIconGraphic();
  }

  disable() {
    this.btnEnabled = false;
    this.isOver = false;
    this.input.useHandCursor = false;
    this.events.onInputDown.removeAll();
    this.events.onInputOver.removeAll();
    this.events.onInputOut.removeAll();
    this.inputEnabled = false;
    this.updateIconGraphic();
  }

  /*
  =============================================================================================================
    GAME PAUSED MANAGEMENT
  =============================================================================================================
  */

  handleGamePaused() {
    this.game.canvas.addEventListener('mousemove', this.bindedHandlePausedMouseMove);
    this.game.input.onDown.add(this.handlePausedMouseDown, this);
  }

  handleGameResumed() {
    this.game.canvas.removeEventListener('mousemove', this.bindedHandlePausedMouseMove);
    this.game.input.onDown.remove(this.handlePausedMouseDown, this);
  }

  handlePausedMouseMove(e, x, y) {
    if (this.btnEnabled) {
      const mouseOver = this.isWithinBounds(
        x || this.game.input.mousePointer.x,
        y || this.game.input.mousePointer.y
      );
      if (mouseOver && this.isOver === false) {
        // this.icon.loadTexture(this.buttontexture, this.over);
        this.game.canvas.style.cursor = 'pointer';
        this.onOver();
      } else if (mouseOver === false && this.isOver === true) {
        this.isOver = false;
        this.game.canvas.style.cursor = 'default';
        this.updateIconGraphic();
      }
      this.isOver = mouseOver;
    }
  }

  handlePausedMouseDown(e) {
    this.handlePausedMouseMove(e, e.x, e.y);
    if (this.isOver && this.btnEnabled) {
      this.onDown();
    }
  }

  /*
  =============================================================================================================
    ROLLOVR STATES
  =============================================================================================================
  */

  onOut() {
    this.isOver = false;
    this.updateIconGraphic();
  }

  onOver() {
    this.isOver = true;
    this.updateIconGraphic();
  }

  inputDown() {
    if (!this.game.paused) {
      this.onDown();
    }
  }

  onDown() {
    if (this.btnEnabled) {
      if (!this.isMute) {
        this.game.sounds.playSFX('click', { volume: 0.5 });
      }
      this.isOver = true;
      this.updateIconGraphic();
      this.onInputDown.dispatch(this);
      // vibrate.vibrate();
    }
  }

  updateIconGraphic() {
    if (!this.btnEnabled || this.disabled) {
      this.costume.panel.tint = this.buttonStates.disabled.bg;
      this.costume.contentDisplay.tint = this.buttonStates.disabled.font;
      this.costume.alpha = this.buttonStates.disabled.alpha || 1;
    } else {
      this.costume.panel.tint = this.isOver ? this.buttonStates.over.bg : this.buttonStates.up.bg;
      this.costume.contentDisplay.tint = this.isOver
        ? this.buttonStates.over.font
        : this.buttonStates.up.font;
      this.costume.alpha = 1;
    }
  }

  /*
  =============================================================================================================
    WINDOW CHANGE MANAGEMENT
  =============================================================================================================
  */

  manageSize() {
    /*
    this.gameScale = this.game.canvas.clientHeight / this.game.height;

    // grab minimum size based on canvas width
    if (this.game.canvas.clientWidth < 770) {
      this.minSize = Math.max(this.minSizeNarrow, this.minSizeNarrow / this.gameScale);
    } else {
      this.minSize = Math.max(this.minSizeWide, this.minSizeWide / this.gameScale);
    }

    this.costume.scale.set(1);
    this.minSize = Math.min(
      this.minSize,
      this.game.canvas.clientWidth < 770 ? this.maxSizeNarrow : this.maxSizeWide
    );

    const targetScale = this.minSize / this.costume.panel.height;
    this.costume.scale.set(targetScale);

    this.hitArea = new Phaser.Rectangle(
      0,
      0,
      Math.max(this.minSize, this.costume.panel.width * targetScale),
      Math.max(this.minSize, this.costume.panel.height * targetScale)
    );
    */
  }

  /*
  =============================================================================================================
    OTHER
  =============================================================================================================
  */

  isWithinBounds(x, y) {
    if (this.btnEnabled) {
      const bounds = this.getBounds();
      if (this.hitArea) {
        bounds.width = this.hitArea.width;
        bounds.height = this.hitArea.height;
      }
      return bounds.contains(x, y);
    }
    return false;
  }

  /*
  =============================================================================================================
    DESTROY
  =============================================================================================================
  */

  destroy(destroyChildren = true) {
    this.onInputDown.removeAll();
    this.events.onInputOver.remove(this.onOver, this);
    if (this.game) {
      this.game.onPause.remove(this.handleGamePaused, this);
      this.game.onResume.remove(this.handleGameResumed, this);
      this.game.input.onDown.remove(this.handlePausedMouseDown, this);
      this.game.scale.onSizeChange.remove(this.manageSize, this);
      if (this.game.canvas) {
        this.game.canvas.removeEventListener('mousemove', this.bindedHandlePausedMouseMove);
      }
      this.disable();
    }

    this.costume.destroy(true);
    this.onInputDown = null;
    this.shadow = null;
    this.panel = null;

    super.destroy(destroyChildren);
  }
}
